import React from 'react';
import moment from 'moment';
import axios from 'axios';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import AnnouncementCard from '../parts/AnnouncementCard';

const styles = theme => ({
  sectionHeading: {
    color: '#394f5a',
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class AnnouncementsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: false,
      isLoaded: false,
      meta: [],
    };

    this.axiosCancel = null;
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
      isLoaded: false,
    });

    axios
      .get(
        `${window.apiUrl}/announcements/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
            meta: response.data.meta,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      t,
    } = this.props;
    const {
      data,
      isLoaded,
      isLoading,
    } = this.state;

    return (
      <div className="announcements-page">
        <Typography
          className={classes.sectionHeading}
          variant="h5"
          component="h5"
        >
          {t('Announcements')}
        </Typography>
        {isLoading && !isLoaded
          && (
          <div>
            <CircularProgress />
          </div>
          )
        }
        <br />
        {!isLoading && isLoaded && data.length > 0 && data.map(announcement => (
          <AnnouncementCard
            key={announcement.id}
            announcement={announcement}
            onClose={() => { this.reloadData(); }}
            useSuspense={false}
          />
        ))}
        {!isLoading && isLoaded && data.length === 0
          && <div>{t('No announcements at the moment.')}</div>
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(AnnouncementsPage))
);
